import { CustomProductList } from '@catalog/const';
import { customProductListUrlMatcher } from '@catalog/utils';
import { customProductDetailsUrlMatcher } from '@product/utils';
import { DEFAULT_URL_MATCHER, RouteLoadStrategy, RoutesConfig, RoutingConfig } from '@spartacus/core';
import { LOGIN_ROOT_PATH, LOGIN_TYPES } from '@user/const';

const routesConfig: RoutesConfig = {
  search: {
    paths: ['search/:query', 'search'],
  },
  bonuses: { paths: ['my-account/bonuses'] },
  coupons: { paths: ['my-account/coupons'] },
  payments: { paths: ['my-account/payments'] },
  personalManagers: { paths: ['my-account/personal-managers'] },
  [CustomProductList.PromoProductList]: {
    matchers: [DEFAULT_URL_MATCHER],
    paths: [
      // Порядок путей не менять, DEFAULT_URL_MATCHER работает только так
      'p/:promoCode/:categoryCode',
      'p/:promoCode',
      'g/:promoCode/:categoryCode',
      'g/:promoCode',
    ],
    paramsMapping: { categoryCode: 'code' },
  },
  product: {
    matchers: [customProductDetailsUrlMatcher],
    paths: ['product/:uriName'],
    paramsMapping: { productCode: 'code' },
  },
  category: {
    matchers: [DEFAULT_URL_MATCHER, customProductListUrlMatcher],
    paths: ['category/:categoryCode'],
    paramsMapping: { categoryCode: 'code' },
  },
  [CustomProductList.SeoProductList]: {
    paths: ['s/:tagSlug'],
  },
  [CustomProductList.SaleProductList]: {
    paths: ['sales/:categoryCode', 'sales'],
    paramsMapping: { categoryCode: 'code' },
  },
  [CustomProductList.BestOffersProductList]: {
    paths: ['best-offers/:categoryCode', 'best-offers'],
    paramsMapping: { categoryCode: 'code' },
  },
  articleList: {
    paths: ['articles'],
  },
  articleDetail: {
    paths: ['articles/:code'],
  },
  comparison: {
    paths: ['comparison'],
  },
  addCompany: {
    paths: ['add-company'],
  },
  updateProfile: {
    paths: ['my-account/update-profile'],
  },
  myAccount: {
    paths: ['my-account'],
  },
  companiesList: {
    paths: ['my-account/companies-list'],
  },
  bonus: {
    paths: ['my-account/points'],
  },
  orderDocuments: {
    paths: ['my-account/order-documents'],
  },
  wishlist: {
    paths: ['wishlist'],
  },
  trackingPickup: {
    paths: ['track/:orderGuid'],
    paramsMapping: { orderGuid: 'guid' },
  },
  assignManager: {
    paths: ['assign-manager/:managerUid'],
  },
  loginLoyalty: {
    paths: ['login-loyalty'],
  },
  loginByCall: {
    paths: [`${LOGIN_ROOT_PATH}/${LOGIN_TYPES.CALL}`],
    authFlow: true,
  },
  loginByCode: {
    paths: [`${LOGIN_ROOT_PATH}/${LOGIN_TYPES.CODE}`],
    authFlow: true,
  },
  loginByPassword: {
    paths: [`${LOGIN_ROOT_PATH}/${LOGIN_TYPES.PASSWORD}`],
    authFlow: true,
  },
  giftery: {
    paths: ['elektronnyj-podarochnyj-sertifikat'],
  },
  orders: {
    paths: ['my-account/orders'],
  },
  orderDetails: {
    paths: ['my-account/order/:orderCode'],
    paramsMapping: { orderCode: 'code' },
  },
  cart: { paths: ['cart'] },
  home: { paths: [''] },
};

export const routingConfig: RoutingConfig = {
  routing: {
    routes: routesConfig,
    // Баннеры у нас на рестрикшинах по категориям.
    // Потому что категорийная страница 1 на всех
    // когда то это бэкендеры победят
    // Но пока что мы не можем не перезапрашивать данные для страниц
    loadStrategy: RouteLoadStrategy.ALWAYS,
  },
};
